var OCS = OCS || {};
OCS.Worker = OCS.Worker || {};
OCS.Worker.Config = OCS.Worker.Config || {};
OCS.Worker.Classes = OCS.Worker.Classes || {};
OCS.Worker.Functions = OCS.Worker.Functions || {};
OCS.Worker.Functions.define_lightning_worker = function () {
    OCS.Worker.Classes.LightningWorker = new Class({
        Implements: [Options, Events],
        options: {
            dataset: 'edu.ou.ocs.lightning',
            manager_name: 'lightning_worker',
            time_update_interval: 20 * 1000, // Move time forward every 20 seconds
            datetime_anchor: false,
            datetime_settings: {},
            debug: false
        },
        changed: true,
        out: null,
        bound_methods: {},
        processor: null,
        process_output_timeout: null,
        data: {},
        current_time_update_count: 0,
        reset_on_time_update: 7,
        initialize: function (op) {
            this.setOptions(op);
            this.bound_methods.process_command = this.process_command.bind(this);
            this.bound_methods.on_send_to_ui = this.on_send_to_ui.bind(this);
            this.bound_methods.on_time_update = this.on_time_update.bind(this);
            this.bound_methods.destroy = this.destroy.bind(this);
            var datetime_ops = {time_interval: this.options.time_update_interval};
            if (this.options.datetime_anchor) {
                datetime_ops.anchor = true;
            }
            var datetime = OCS.Functions.get_OCSDateTime(datetime_ops);
            if (this.options.datetime_anchor) {
                datetime.set_current_time_settings(this.options.datetime_settings, true);
                datetime.set_anchor(this.options.datetime_settings.end);
            }
            datetime.addEvent('time_update', this.bound_methods.on_time_update);
            if (OCS.is_worker) {
                var thread = OCS.Worker.Functions.get_processor({constant: true});
                thread.addEvent('command', this.bound_methods.process_command);
                thread.addEvent('destroy', this.bound_methods.destroy);
                thread.addEvent('debug', OCS.Worker.Functions.define_debug_info);
            }
            this.processor = new OCS.Worker.Classes.LightningProcessing({entry: {json: {data: {features: [], type: "FeatureCollection"}, dataset: this.options.dataset, info: {timestamp: 0, variables: [{'parm': 'lightning'}]}}}});
            this.processor.data = this.data;
        },
        process_command: function (ev) {
            if (ev && ev.data && ev.data.cmd) {
                var data = ev.data;
                var ops = {};
                if (data.options) {
                    ops = data.options;
                }
                switch (data.cmd) {
                    case 'event':
                        var event_name = ops.event;
                        var event_data = ops.event_data;
                        if (event_name) {
                            this.fireEvent(event_name, event_data);
                        }
                        break;
                    case 'process_data':
                        this.process_data(OCS.Functions.define_data_obj(ops));
                        break;
                    case 'stop':
                        this.destroy();
                        break;
                }
            }
        },
        process_data: function (data_obj) {
            var feature, i;
            var dateObj = OCS.Functions.get_OCSDateTime();
            var existing_data, datetime;
            var data_in = data_obj.data();
            OCS.Worker.Functions.debug_info("process_data called with "+data_in.features.length+" features.");

            for (i = 0; i < data_in.features.length; i++) {
                if (data_in.features[i]) {
                    feature = data_in.features[i];
                    datetime = dateObj.get_frame_from_timestamp(feature.properties.timestamp);
                    existing_data = this.get_stored_data(datetime);
                    existing_data.add_data_variable(feature, OCS.Worker.Functions.get_lightning_key(feature, datetime));
                }
            }
            this.processor.changed();
        },
        process_output: function () {
            var timeout = 1000;
            if (OCS.is_worker) {
                timeout = 10;
            }
            if (!this.process_output_timeout) {
                this.process_output_timeout = setTimeout(this.on_process_output_timeout.bind(this), timeout);
            }

        },
        get_stored_data: function (datetime) {
            if (!this.data[datetime]) {
                this.data[datetime] = OCS.Functions.define_data_obj({entry: {json: {data: {features: [], type: "FeatureCollection"}, dataset: this.options.dataset, info: {timestamp: datetime, variables: [{'parm': 'lightning'}]}}}});
            }
            return this.data[datetime];
        },
        on_send_to_ui: function (cmd, ops) {
            if (OCS.is_worker) {
                OCS.Worker.Functions.send_to_main({cmd: cmd, options: ops});
            } else {
                this.fireEvent('worker_message', {'cmd': cmd, 'options': ops});
            }
        },
        on_time_update: function (datetime) {
            this.current_time_update_count++;
            OCS.Worker.Functions.debug_info("on_time_update called.");
            if (this.current_time_update_count > this.reset_on_time_update) {
                this.current_time_update_count = 0;
                this.processor.reset();
            }
            var start = datetime.get_frame_from_timestamp(datetime.get_start_epoch_time());
            var timestamp = datetime.get_frame_from_timestamp(datetime.get_current_epoch_time());
            var times = Object.keys(this.data);
            var i, time;
            var length = times.length;
            for (i = 0; i < length; i++) {
                time = times[i];
                if (start > parseInt(time)) {
                    delete this.data[time];
                    continue;
                }
            }
            if (!this.processor.completed) {
                this.process_output();
            }
            this.processor.out.options.entry.json.info.timestamp = timestamp;
            if (this.processor.completed || !OCS.is_worker) {
                var out_data = this.processor.out.data();
                if (out_data.features.length) {
                    OCS.Worker.Functions.debug_info("Sending current lightning to main thread with "+out_data.features.length+" features.");
                    this.on_send_to_ui('current_lightning', this.processor.out.stringify());
                }
            }
        },
        on_process_output_timeout: function () {
            this.process_output_timeout = null;
            this.processor.increment();
            this.on_time_update(OCS.Functions.get_OCSDateTime());

        },
        destroy: function () {
            if (this.process_output_timeout) {
                clearTimeout(this.process_output_timeout);
                this.process_output_timeout = null;
            }
            this.processor = null;
            this.on_send_to_ui('stopped', {});

            this.removeEvents();
        }
    });
    OCS.Worker.Classes.LightningProcessing = new Class({
        current: -1,
        end: 0,
        max_runs: 20000,
        current_run: 0,
        runs: 0,
        data: {},
        completed: false,
        initialize: function (data_ops) {
            this.out = OCS.Functions.define_data_obj(data_ops);
        },
        increment: function () {
            if (this.completed) {
                return;
            }

            var times = Object.keys(this.data);
            if (times.length) {
                if (this.end !== times.length || this.current < 0) {
                    // Run through this loop backwards so we get the most recent times first    
                    this.current = times.length - 1;
                    this.end = times.length;
                }
                var j, feature, time, data_in;
                this.runs = 0;
                var max_features = 750;
                var feature_count = 0;
                while ((this.runs < this.max_runs) && (this.current >= 0)) {
                    time = times[this.current];
                    if (this.data[time]) {
                        data_in = this.data[time].data();
                        if (data_in.features.length > max_features) {
                            feature_count = max_features;
                        } else {
                            feature_count = data_in.features.length;
                        }
                        for (j = this.current_run; j < data_in.features.length; j++) {
                            if (data_in.features[j]) {
                                feature = data_in.features[j];
                                this.out.add_data_variable(feature, OCS.Worker.Functions.get_lightning_key(feature, time));
                            }
                            this.runs++;
                            if (this.runs >= this.max_runs) {
                                return;
                            }
                        }
                        if (j >= data_in.features.length) {
                            // it finished
                            this.current_run = 0;
                        }
                    }
                    if (this.current_run === 0) {
                        this.current--;
                    }
                }
                if (this.current <= 0) {
                    this.completed = true;
                }
            } else {
                this.completed = true;
            }
        },
        changed: function () {
            this.completed = false;
            this.current = -1;
        },
        reset: function () {
            this.out.data().features = [];
            this.out.keys = [];
            this.changed();
        }
    });
    OCS.Worker.Functions.get_lightning_key = function (flash, datetime) {
        return datetime + "|" + flash.geometry.coordinates[0] + "," + flash.geometry.coordinates[1];
    };
    if (OCS.is_worker) {
        // Kick off the thread with an understanding it will be running constantly
        OCS.Worker.Functions.get_processor({constant: true});
    }


};
OCS.Worker.Functions.define_debug_info = function () {

    if (OCS.Worker.Settings && OCS.Worker.Settings.debug) {
        if (OCS.is_worker) {
            OCS.Worker.Functions.debug_info = function (info) {
                OCS.Worker.Functions.send_to_main({
                    cmd: 'console_debug',
                    options: {'msg': info, originator: "lightning_worker"}
                });
                return info;
            };
        } else {
            OCS.Worker.Functions.debug_info = function (info) {
                console.debug("lightning_worker:", info);
                return info;
            };
        }
    } else {
        OCS.Worker.Functions.debug_info = function (info) {
            return info;
        };
    }
};
OCS.Worker.Functions.define_lightning_worker();
OCS.Worker.Functions.define_debug_info();